import React from 'react';
import { Field, LinkField, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';
import { PromptForMissingDatasource } from 'src/shared/PromptForMissingDatasource';
import { IconCtaBorderedCard } from '@ahc-digital/component-library';
import { CreateIconCTABorderedCardModel } from './C31IconCTABordered.service';
import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  KeyValuePair,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';

export type C31IconCTABorderedCardProps = RenderingProps<
  C30IconCTABorderedCardFields,
  {
    TitleType?: string;
    TopBorderColor?: string;
    FirstCTAStyle?: string;
    SecondCTAStyle?: string;
  } & DynamicPlaceholderParams &
    TranslationOptionsParams &
    AnchorTargetParams
>;
export type C30IconCTABorderedCardFields = {
  Icon?: KeyValuePair;
  Headline?: Field<string>;
  SupportCopy?: RichTextField;
  FirstCTA?: LinkField;
  SecondCTA?: LinkField;
};

export const Default = (props?: C31IconCTABorderedCardProps): JSX.Element => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  if (!props?.rendering?.dataSource)
    return <PromptForMissingDatasource rendering={props?.rendering} />;
  return (
    <IconCtaBorderedCard
      className={translationClasses(props?.params)}
      id={props?.params?.AnchorLinkTargetName}
      data-component={marketingRenderingName}
      {...CreateIconCTABorderedCardModel(props)}
    />
  );
};
